import React from 'react'
import Banner from '../components/Banner'
import { useTranslation } from 'react-i18next'
import Video from '../assets/BannerVideo2.mp4'
import PriceServices from '../components/PriceServices'

const PriceList = () => {
  const { t } = useTranslation();
  return (
   <div>
    <Banner videoSrc={Video} title={t('bannerTitlePriceList')} bannerInfo={t('elevateWellnessJourney')} buttonText={t('bookAppointent')} />
    <PriceServices/>
   </div>  
  )
}

export default PriceList
